import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SearchObject, SearchObjectService } from '../../services/search-object.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationContainerService {

  notificationChange: Subject<boolean> = new Subject<boolean>();
  messages = [];

  constructor(private searchObjectService: SearchObjectService) {
  }

  clearMessages() {
    this.messages = [];
    this.notificationChange.next(null);
  }

  getMessages() {
    for (const message of this.messages) {
      message.showmore = false;
    }
    return this.messages;
  }

  showSearchMessage(searchObject: SearchObject) {

    if (searchObject.filters.subProductKey === '17'
    || searchObject.filters.subProductKey === '61'
    || searchObject.filters.subProductKey === '70'
    || searchObject.filters.subProductKey === '82'
    || searchObject.filters.subProductKey === '97'
    || searchObject.filters.subProductKey === '11'
    || searchObject.filters.subProductKey === '96'
    || searchObject.filters.subProductKey === '101'
    || searchObject.filters.subProductKey === '64'
    || searchObject.filters.subProductKey === '65'
    || searchObject.filters.subProductKey === '81'
    || searchObject.filters.subProductKey === '99') {
      this.levelMessage();
    }

    if ((searchObject.careType === 'Medical' || searchObject.careType === 'Behavioral Health')
      && (searchObject.networkId === '0000010000010001100006' || searchObject.networkId === '0000010000010001200004')
      && !searchObject.filters.subProductKey
      && searchObject.loginType !== 'find') {
        this.medicareMessage();
    }

    if ((searchObject.careType === 'Medical' || searchObject.careType === 'Behavioral Health')
      && (searchObject.networkId === '0000010000010001100006' || searchObject.networkId === '0000010000010001200004')
      && searchObject.filters.subProductKey === '90') {
        this.medicareExcelaMessage();
    }

    if ((searchObject.careType === 'Dental')
      && (searchObject.networkId === '0000010000010001300005')
      && !searchObject.filters.subProductKey) {
        this.medicareDentalMessage();
    }

    if ((searchObject.careType === 'Dental')
      && (searchObject.networkId === '0000010000010001300001')) {
        this.commercialDentalMessage();
    }

    if ((searchObject.careType === 'Medical')
      && (searchObject.networkId === '0000010000010001100001' || searchObject.networkId === '0000010000010001100001')
      && !searchObject.filters.subProductKey
      && searchObject.loginType !== 'find' && searchObject.loginType !== 'shop' && searchObject.loginType !== 'employer') {
        this.multipleNetworkMessage();
    }

    if ((searchObject.careType === 'Medical')
      && searchObject.specialty === 'Urgent Care & Convenience Care Clinics'
      && searchObject.loginType !== 'find' && searchObject.loginType !== 'shop' && searchObject.loginType !== 'employer') {
      this.urgentConvenienceCareMessage();
    }

    if ((searchObject.careType === 'Medical')
      && (searchObject.networkId === '0000010000010001100001')
      && searchObject.filters.subProductKey === '96') {
        this.subkey96Message();
    }

    if ((searchObject.careType === 'Medical' || searchObject.careType === 'Behavioral Health')
      && (searchObject.networkId === '0000010000010001100001')
      && searchObject.filters.subProductKey === '98'
      && searchObject.filters.planDisplayKey === '13') {
      this.outOfAreaMessage();
    }

    if ((searchObject.careType === 'Medical')
      && (searchObject.networkId === '0000010000010001100009')
      && (searchObject.filters.subProductKey === '108')) {
      this.towerSearchMessage();
    }

    if ((searchObject.careType === 'Pharmacy')
      && (searchObject.networkId === '0000010000010001600001')
      && (!searchObject.filters.subProductKey)) {
      this.pharmacyNetworkMessage();
    }

    if ((searchObject.careType === 'Pharmacy')
      && (searchObject.networkId === '0000010000010001600001')
      && (searchObject.filters.subProductKey === '210')) {
      this.pharmacyLevelMessage();
    }

    if ((searchObject.careType === 'Pharmacy')
      && (searchObject.networkId === '0000010000010001600004')
      && (searchObject.filters.subProductKey === '204')) {
      this.pharmacyMedicareLevelMessage();
    }

    if (((!searchObject.county && this.checkCrawfordCountyZipcode(searchObject.zipCode)) || searchObject.county === 'Crawford')
    && ((searchObject.networkId === '0000010000010001600005' && searchObject.filters.subProductKey === '204')
    || (searchObject.networkId === '0000010000010001600004' && searchObject.filters.subProductKey === '204'))) {
      this.crawfordMessage();
    }

    this.notificationChange.next(null);
  }

  showNoResultsMessages(searchObject: SearchObject) {
    if ((searchObject.careType === 'Medical' || searchObject.careType === 'Behavioral Health')
      && (searchObject.networkId === '0000010000010001100001')
      && searchObject.filters.subProductKey === '98'
      && searchObject.filters.planDisplayKey === '13') {
      this.outOfAreaMessage();
    }

    this.notificationChange.next(null);
  }

  outOfAreaMessages(data: any, searchObject: SearchObject) {
    let isInNetwork = false;
    let otherOOA = false;
    const currSubKey = searchObject.filters.subProductKey;
    let networkObj = [];

    if (!this.searchObjectService.isCigna()) {

      if (currSubKey) {
        networkObj = data.networks.filter(obj => obj.subProductKey == currSubKey);
        if (networkObj.length > 0) {
          isInNetwork = networkObj[0].isInNetwork;
        } else {
          isInNetwork = data.isInNetwork;
        }
      } else {
        isInNetwork = data.isInNetwork;
      }

      if (!isInNetwork) {

        if ((searchObject.careType === 'Medical' || searchObject.careType === 'Behavioral Health')
          && (searchObject.networkId === '0000010000010001100006'
          || searchObject.networkId === '0000010000010001100005'
          || searchObject.networkId === '0000010000010001100008'
          || searchObject.networkId === '0000010000010001100007'
          || searchObject.networkId === '0000010000010001200005' 
          || searchObject.networkId === '0000010000010001200006')) {
          this.ooaGovernmentMedical();
          otherOOA = true;
        }

        if (searchObject.networkId === '0000010000010001500001') {
          this.ooaGovernmentMedical();
          otherOOA = true;
        }

        if ((searchObject.networkId === '0000010000010001100003')
          || (searchObject.filters.subProductKey === '85')) {
          this.ooaGovernmentMedical();
          otherOOA = true;
        }

        if ((searchObject.networkId === '0000010000010001200004') ||
          (
            (searchObject.networkId === '0000010000010001200004')
            && (searchObject.filters.subProductKey === '25'
            || searchObject.filters.subProductKey === '80')
          )
        ) {
            this.ooaGovernmentMedical();
            otherOOA = true;
        }

        if ((searchObject.careType === 'Vision')
          && (searchObject.networkId === '0000010000010001400002'
          || searchObject.networkId === '0000010000010001400001'
          || searchObject.networkId === '0000010000010001400005'
          || searchObject.networkId === '0000010000010001400006')) {
          this.outOfAreaVisionMessage();
          otherOOA = true;
        }

        if ((searchObject.careType === 'Medical')
          && (searchObject.networkId === '0000010000010001100009')
          && (searchObject.filters.subProductKey === '108')) {
          this.ooaTowerHealth();
          otherOOA = true;
        }

        if (searchObject.careType === 'Medical'
          && (searchObject.networkId === '0000010000010001100010')
          && (searchObject.filters.subProductKey === '211')) {
            // this.ooaStudentMessage();
            this.outOfAreaMessage();
            otherOOA = true;
        }

        if (!otherOOA && searchObject.careType !== 'Dental' && searchObject.filters.subProductKey !== '98') {
            this.outOfAreaMessage();
        }

        this.notificationChange.next(null);
      }
    }

    if ((searchObject.careType === 'Medical' || searchObject.careType === 'Behavioral Health')
      && (searchObject.networkId === '0000010000010001100001')
      && searchObject.filters.subProductKey === '98'
      && !isInNetwork && this.searchObjectService.isLoggedIn()) {
      this.outOfAreaMessage();
    }
  }

  levelMessage() {
    this.messages.push(
      new Message(true, false, null, null, `This network has multiple benefit levels to consider when you receive care. <a>What does this mean?</a>`,
      ``,
      ` `,
      `<strong>Level 1 Network:</strong> Means lowest out-of-pocket cost for members<br><br><strong>Level 2 Network:</strong> Means higher out-of-pocket cost for members and access to more providers`)
    );
  }

  medicareMessage() {
    this.messages.push(
      new Message(true, false, null, null, ``,
      `Some UPMC <i>for Life</i> networks have a select network of providers that you must use for your care. This is different from a typical HMO or PPO provider network. For those networks, you will not have access to the full UPMC <i>for Life</i> provider network. Using providers that do not participate in your network could mean that your care is not covered or you will pay a higher cost-sharing. <strong>Use the network filter above to ensure that your results return only providers that participate in your network.</strong>`)
    );
  }

  medicareExcelaMessage() {
    this.messages.push(
      new Message(true, false, null, null, ``,
      `This plan has tiered cost-sharing. Tier 1 includes Excela Health and most UPMC facilities, excluding UPMC East and UPMC McKeesport.  Tier 2 includes UPMC East and McKeesport. Tiered cost-sharing will apply to certain services in 2020. For more information, see the Summary of Benefits for this plan.`)
    );
  }

  medicareDentalMessage() {
    this.messages.push(
      new Message(true, false, null, null, ``,
      `If you are enrolled in a UPMC <i>for Life</i> Medicare Advantage Employer Group Network, please review your Evidence of Coverage to see if you have routine dental coverage`)
    );
  }

  commercialDentalMessage() {
    this.messages.push(
      new Message(true, false, null, null, ``,
      `This type of coverage includes providers for pediatric dental essential health benefits. Refer to your benefit documents for applicability.`)
    );
  }

  pharmacyNetworkMessage() {
    this.messages.push(
      new Message(true, false, null, null, ``,
      `Multiple pharmacy networks will be available starting January 1st, 2023. Be sure to select the appropriate network using the Network Accepted filter above.`)
    );
  }

  multipleNetworkMessage() {
    this.messages.push(
      new Message(true, false, null, null, ``,
      `This type of coverage has multiple benefit levels to consider when you receive care. Please select a network in the filter options above to view more detailed results.`)
    );
  }

  urgentConvenienceCareMessage() {
    this.messages.push(
      new Message(true, false, null, null,
      `These search results contain both Urgent Care and Convenience Care locations. <a>What is the difference?</a>`,
      ``,
      ` `,
      `<br>
      <p><strong>Urgent care centers:</strong> These are walk-in clinics and are designed to treat medical issues that need prompt care but are not severe enough for an ER visit. These issues may include minor injuries and infections. Urgent care centers also offer diagnostic tests, x-rays, and other basic medical care. The centers often have extended hours.</p>
      <br>
      <p><strong>Convenience care centers:</strong> These centers provide quick, easy access to medical care and are often found in retail settings like pharmacies. The centers offer basic medical services like shots and care for minor concerns. The convenience care center may be able to treat breathing problems, cold and flu symptoms, and rashes. This type of care center is best when you want to be seen without an appointment or long wait.</p>
      <br>
      <p><i>Costs may vary based on your specific insurance plan. Please refer to your schedule of benefits or member handbook for urgent/convenience care coverage. You can also call the number on your member ID card.<i></p>
      `)
    );
  }

  subkey96Message() {
    this.messages.push(
      new Message(true, false, null, null, `The UPMC Employee Advantage Network is available to UPMC employees working in western NY. The providers and facilities listed below have been credentialed. <a>What does this mean?</a>`,
      ``,
      ` `,
      `UPMC employees working in western New York will have access to the Advantage Network (Level 1) that includes UPMC-owned hospitals and facilities along with the following hospitals and their associated physicians:
      <br><br>
      <ul>
        <li>Kaleida Health</li>
        <li>Catholic Health</li>
        <li>Brooks Memorial Hospital</li>
        <li>Roswell Park Cancer Institute</li>
      </ul>
      <br>
      UPMC Health Plan has established contracts with Catholic Health, Roswell Park Cancer Institute, and their associated physicians. You can continue to access Kaleida Health & Brooks Memorial Hospital through the extended network - <a href="https://www.multiplan.com/webcenter/portal/ProviderSearch?ProviderSearchConfig=ClientSite&SiteUrlSuffix=upmcemployee" target="_blank">PHCS MultiPlan</a>.
      <br><br>
      For assistance locating a provider, contact the UPMC Health Plan Health Care Concierge team at 1-844-833-0524. They are available Monday through Friday from 7 a.m. to 7 p.m. and Saturday from 8 a.m. to 3 p.m. TTY users should call 711.
      `)
    );
  }

  towerSearchMessage() {
    this.messages.push(
      new Message(true, true, 'https://cdn.upmchp.com/providerdirectory/assets/clientImages/TowerHealth/TowerHealth_VT_RGB.png', 'Tower Health Logo', `This network has multiple benefit levels to consider when you receive care. <a>What does this mean?</a>`,
      '',
      ' ',
      `<strong>Level 1 Network:</strong> Means lowest out-of-pocket cost for members<br><br><strong>Level 2 Network:</strong> Means higher out-of-pocket cost for members and access to more providers
      <br><br>
      Disclaimer:  These online directories include lists of providers and the information contained therein is updated periodically and subject to change.  Tower Health Plan recommends that you contact the providers listed in this directory to confirm their information is current.  Please note that for Reading employee plans, Lancaster General Hospital and its providers as well as the Hospital of the University of Pennsylvania are not participating.`)
    );
  }

  pharmacyLevelMessage() {
    this.messages.push(
      new Message(true, false, null, null, `This network has multiple benefit levels to consider when you receive care. <a>What does this mean?</a>`,
      ``,
      ` `,
      `Our network includes standard pharmacies and preferred pharmacies. You may go to either type of network pharmacy to fill most covered prescription drugs. You can receive the lowest copays available when you fill your covered prescriptions at a preferred pharmacy.
      <br><br>
      <strong>Preferred:</strong> Means these pharmacies offer the lowest out-of-pocket cost for covered prescription drugs<br><br><strong>Standard:</strong> Means these pharmacies have a higher out-of-pocket cost for covered prescription drugs`)
    );
  }

  pharmacyMedicareLevelMessage() {
    this.messages.push(
      new Message(true, false, null, null, `This network has multiple benefit levels to consider when you receive care. <a>What does this mean?</a>`,
      ``,
      ` `,
      `Our network includes standard pharmacies and preferred pharmacies. You may go to either type of network pharmacy to fill most covered prescription drugs. You can receive the lowest copays available when you fill your covered prescriptions at a preferred pharmacy.  This does not apply to members receiving low-income subsidies (LIS).
      <br><br>
      <strong>Preferred:</strong>Means these pharmacies offer the lowest out-of-pocket cost for covered prescription drugs<br><br><strong>Standard:</strong> Means these pharmacies have a higher out-of-pocket cost for covered prescription drugs`)
    );
  }

  crawfordMessage() {
    this.messages.push(
      new Message(true, false, null, null, ``,
      `UPMC Health Plan's pharmacy network includes limited lower-cost, preferred pharmacies in Crawford County, Pennsylvania. The lower costs advertised in our plan materials for these pharmacies may not be available at the pharmacy you use. For up-to-date information about our network pharmacies, including whether there are any lower-cost preferred pharmacies in your area, please call 1-877-539-3080 <strong>(TTY: 711)</strong>.`
      )
    );
  }
  // For a list of providers that are in the process of being confirmed that may not appear in the online directory, please <a href="${link}" target="blank">click here</a>.


  // Out of Area Messages
  outOfAreaMessage() {
    this.messages.push(
      new Message(true, false, null, null, `The location you entered is outside UPMC Health Plan's service area.`,
      ``,
      `Find care outside UPMC Health Plan's service area.`,
      `<ul>Find care outside the UPMC Health Plan's service area if you are a member and are:
        <li>Traveling and in need of emergency or urgent care</li>
        <li>Enrolled in an extended network/out-of-area plan</li>
        <li>Enrolled in UPMC National Access</li>
        <li>A dependent attending school/living outside UPMC Health Plan's service area</li>
      </ul>
      <br>
      <strong>Please select the appropriate link below for when you will be receiving care.</strong>
      <br><br>
      <ul>
        <li><a href="https://medmutual.healthsparq.com/healthsparq/public/#/one/insurerCode=MMO_I&brandCode=SMN&productCode=01" target="_blank">Care in Ohio</a></li>
        <li><a href="https://findcare.upmchealthplan.com/find?type=shop&network=Cigna%20Extended%20Network" target="_blank">All other states</a></li>
        <li><a href="https://www.upmchealthplan.com/members/self-service-resources/travel-coverage.aspx" target="_blank">Learn about Travel Coverage with Assist America</a></li>
      </ul>
      <br>
      For additional help obtaining care outside of UPMC Health Plan's service area, please call a Health Care Concierge at 1-844-881-4146.
      `)
    );
  }

  outOfArea98Message() {
    this.messages.push(
      new Message(true, false, null, null, `You have selected the extended network/out-of-area plan.`,
      ``,
      `Find care outside UPMC Health Plan's service area.`,
      `<strong>Find care outside UPMC Health Plan's service area:</strong>
      <br><br>
      <ul>
        <li>For help obtaining care outside UPMC Health Plan's service area, please call a Health Care Concierge at 1-844-881-4146.</li>
        <li>For other options, please click one of the links below:
          <ul>
            <li><a href="https://medmutual.healthsparq.com/healthsparq/public/#/one/insurerCode=MMO_I&brandCode=SMN&productCode=01" target="_blank">Care in Ohio</a></li>
            <li><a href="https://www.multiplan.com/webcenter/portal/ProviderSearch?ProviderSearchConfig=ClientSite&SiteUrlSuffix=upmcemployee" target="_blank">UPMC Employees: Care Outside Western Pa. and Ohio</a></li>
            <li><a href="https://www.multiplan.com/webcenter/portal/ProviderSearch?ProviderSearchConfig=ClientSite&SiteUrlSuffix=upmcnonemployee" target="_blank">All Other Members: Care Outside Western Pa. and Ohio</a></li>
            <li><a href="https://www.upmchealthplan.com/members/self-service-resources/travel-coverage.aspx" target="_blank">Learn about Travel Coverage with Assist America</a></li>
          </ul>
        </li>
      </ul>
      `)
    );
  }

  outOfAreaVisionMessage() {
    this.messages.push(
      new Message(true, false, null, null, `The location you entered is outside UPMC Health Plan's service area.`,
      ``,
      `Find care outside UPMC Health Plan's service area.`,
      `<ul>If you are a member and are:
        <li>Traveling and in need of emergency or urgent care</li>
        <li>Enrolled in an extended network/out-of-area plan</li>
        <li>A dependent attending school/living outside UPMC Health Plan's service area</li>
      </ul>
      <br>
      <p><strong>Some of our plans have extended areas of coverage. Select a plan to see its extended network:</strong></p>
      <ul>
        <li><a href="https://visionbenefits.envolvehealth.com/upmcvision/" target="_blank">UPMC Vision Advantage</a></li>
      </ul>
      `)
    );
  }

  ooaGovernmentMedical() {
    this.messages.push(
      new Message(true, false, null, null, `The location you entered is outside UPMC Health Plan's service area.`,
      ``)
    );
  }

  ooaTowerHealth() {
    this.messages.push(
      new Message(true, false, null, null, `The location you entered is outside UPMC Health Plan's service area.`,
      ``,
      `Find care outside UPMC Health Plan's service area.`,
      `<ul>If you are a member and are:
        <li>Traveling and in need of emergency or urgent care</li>
        <li>Enrolled in an extended network/out-of-area plan</li>
        <li>A dependent attending school/living outside UPMC Health Plan's service area</li>
      </ul>
      <br>
      <strong>Find care outside of UPMC Health Plan's service area:</strong>
      <br><br>
      <ul>
        <li>For help obtaining care outside UPMC Health Plan's service area, please call a Health Care Concierge at 1-844-770-4102.
          <ul>
            <li><a href="https://medmutual.healthsparq.com/healthsparq/public/#/one/insurerCode=MMO_I&brandCode=SMN&productCode=01" target="_blank">Care in Ohio</a></li>
            <li><a href="https://www.multiplan.com/webcenter/portal/ProviderSearch?ProviderSearchConfig=ClientSite&SiteUrlSuffix=upmctower" target="_blank">Care outside of Western Pa. and Ohio</a></li>
          </ul>
        </li>
      </ul>
      `)
    );
  }

  ooaStudentMessage() {
    this.messages.push(
      new Message(true, false, null, null, `The location you entered is outside UPMC Health Plan's service area.`,
      ``,
      ' ',
      `<ul>If you are enrolled in a UPMC Student Advantage plan and need care while you are outside UPMC Health Plan’s service area, you have the following options:<br><br>
        <li>Call a Health Care Concierge at 1-844-881-4146 (TTY: 711) for help finding a provider.</li>
        <li>Click one of the links below:
          <ul><br>
            <li><a href="https://providersearch.medmutual.com/?logo=SMN&networkcode=SM%2b" target="_blank">Find Care in Ohio</a></li>
            <li><a href="http://www.multiplan.com/upmcnonemployee" target="_blank">All Other Members: Find Care Outside Western Pa. and Ohio</a></li>
            <li><a href="https://www.upmchealthplan.com/members/self-service-resources/travel-coverage.aspx" target="_blank">Learn About Emergency Travel Assistance with Assist America</a></li>
          </ul>
        </li>
      </ul>
      `)
    );
  }

  noSearchResultMessage(mileRadius: string, zipCode: string) {
    this.messages.push(
      new Message(true, false, null, null, ``,
      `We found no results within <a>${mileRadius} miles</a> of <a>${zipCode}</a>, but we found some that are further away.`)
    );
  }

  //crawford county zip hardcode
  private crawfordZipArray = ['16110', '16111', '16125', '16131', '16134', '16314', '16316', '16317', '16327', '16335', '16354',
   '16360', '16362', '16401', '16403', '16404', '16406', '16407', '16412', '16420', '16424', '16432', '16433', '16434', '16435', '16438', '16440', '16441'];
  checkCrawfordCountyZipcode (zipcode) {
    return this.crawfordZipArray.indexOf(zipcode) > -1;
  }

  //county specific msg object
  private countyObj = [
    // {county: 'Allegeny', state: 'NY'},
    // {county: 'Cattaraugus', state: 'NY'},
    // {county: 'Chautauqua', state: 'NY'},
    // {county: 'Monroe', state: 'PA'},
    // {county: 'Pike', state: 'PA'},
    // {county: 'Susquehanna', state: 'PA'},
    // {county: 'Wayne', state: 'PA'},
    // {county: 'Garrett', state: 'MD'},
    // {county: 'Allegany', state: 'MD'},
  ];

  checkOOACounty(county, state) {
    return this.countyObj.find(o => county === o.county && state === o.state);
  }
}

class Message {

  constructor(light, image, imageUrl, imageTitle, header, text, hiddenHeader?, hidden?) {
    this.light = light;
    this.image = image;
    this.imageUrl = imageUrl;
    this.imageTitle = imageTitle;
    this.header = header;
    this.text = text;
    this.hiddenHeader = hiddenHeader;
    this.hidden = hidden;
    this.showmore = false;
  }

  header: string;
  text: string;
  image: boolean;
  imageUrl: string;
  imageTitle: string;
  hiddenHeader?: string;
  hidden?: string;
  light: boolean;
  showmore: false;
}
